<template>
  <div class="header-wrapper">
    <header class="BAP-header">
      <div class="BAP-header__logo">
        <img
          src="../assets/img/logo-centered.jpg"
          alt="Bulls & Apes Project"
        >
      </div>
      <nav
        ref="navEl"
        class="BAP-header__nav"
        :data-active="isDrawerOpen"
      >
        <ul class="BAP-header__nav--menu">
          <NavItem
            v-for="content in contents"
            :key="content.label"
            :items="content.items"
            :link="content.link"
            :label="content.label"
            :announcement="content.announcement"
            :main="!content.items"
            :opened="openedMenu === content.label.toLowerCase().trim()"
            @click="setMenuOpen"
          />
        </ul>
      </nav>
      <div class="BAP-header__socials">
        <a
          v-for="item in social"
          :key="item.label"
          :href="item.link"
          class="BAP-header__nav__button"
          target="_blank"
          rel="noopener noreferrer"
          :title="item.name"
        >
          <img
            :src="item.icon"
            :alt="item.name"
          >
        </a>
      </div>

      <button
        ref="drawerButton"
        :data-active="isDrawerOpen"
        class="BAP-header__drawer-button"
        title="drawer"
        type="button"
        @click="toggleDrawer"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
          />
        </svg>
      </button>
    </header>
    <a
      v-if="showBanner"
      href="/traitranks"
      class="header-announcement"
    >
      <IAlarm
        width="20"
        class="header-announcement-alarm"
      />TraitRanks is live! Check the dynamic rarity rank for your Ape Traits and Apes.
      <ILink
        width="18"
        class="header-announcement-link"
      />
    </a>
  </div>
</template>

<script>
import { contents, social } from "../config/data";
import ILink from "../assets/icons/external-link.svg?inline";
import IAlarm from "../assets/icons/alarm.svg?inline";
import NavItem from "./NavItem.vue";
let openedMenu = "";
let isDrawerOpen = false;

function toggleDrawer() {
  this.isDrawerOpen = !this.isDrawerOpen;
}

function setMenuOpen(e) {
  const menuName = e.target.innerText?.toLowerCase().trim();
  this.openedMenu = this.openedMenu === menuName ? "" : menuName;
}

function closeDrawer() {
  this.isDrawerOpen = false;
}

export default {
  components: {
    IAlarm,
    ILink,
    NavItem,
  },
  data() {
    return {
      contents,
      social,
      openedMenu,
      isDrawerOpen,
    };
  },
  computed: {
    showBanner() {
      return this.$route.name !== 'LootBox'
    },
    hideHeader() {
      return this.$route.meta && this.$route.meta.showHeader === false;
    },
  },
  created() {
    this.clickEvent = null;
    this.resizeEvent = null;
  },
  mounted() {
    var self = this;
    this.resizeEvent = addEventListener(
      "resize",
      function () {
        if (innerWidth > 1150) {
          self.isDrawerOpen = false;
        }
      },
      false
    );
    this.clickEvent = addEventListener(
      "click",
      function (e) {
        if (
          self.isDrawerOpen &&
          !self.$refs.navEl?.contains(e.target) &&
          !self.$refs.drawerButton?.contains(e.target)
        ) {
          self.isDrawerOpen = false;
        }
      },
      false
    );
  },
  unmounted() {
    window.removeEventListener("resize", self.resizeEvent);
    window.removeEventListener("click", self.clickEvent);
  },

  methods: {
    setMenuOpen,
    toggleDrawer,
    closeDrawer,
  },
};
</script>
